import { CalendarDate } from '@internationalized/date';
import {
  UpdatePaymentInput,
  PaymentMethod,
  MoneyInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type PaymentUpdateParams = {
  id: string;
  documentNumber?: string | null;
  transactionDate?: CalendarDate | null;
  amount?: MoneyInput | null;
  paymentMethod?: PaymentMethod | null;
  checkFacilityId?: string | null;
  checkNumber?: string | null;
  checkMemo?: string | null;
  achNumber?: string | null;
  wireNumber?: string | null;
  financialAccountId?: string | null;
  financialAccountTransactionId?: string | null;
};

export const paymentUpdateAtom = createMutationAtomFactory(
  'finance.paymentUpdate',
  (params: PaymentUpdateParams) => {
    const input: UpdatePaymentInput = {};

    if (params.documentNumber !== undefined) {
      input.documentNumber = params.documentNumber;
    }
    if (params.transactionDate !== undefined) {
      input.transactionDate = params.transactionDate?.toString() ?? null;
    }
    if (params.amount !== undefined) {
      input.amount = params.amount;
    }
    if (params.paymentMethod !== undefined) {
      input.paymentMethod = params.paymentMethod;
    }
    if (params.checkFacilityId !== undefined) {
      input.checkFacilityId = params.checkFacilityId;
    }
    if (params.checkNumber !== undefined) {
      input.checkNumber = params.checkNumber;
    }
    if (params.checkMemo !== undefined) {
      input.checkMemo = params.checkMemo;
    }
    if (params.achNumber !== undefined) {
      input.achNumber = params.achNumber;
    }
    if (params.wireNumber !== undefined) {
      input.wireNumber = params.wireNumber;
    }
    if (params.financialAccountId !== undefined) {
      input.financialAccountId = params.financialAccountId;
    }
    if (params.financialAccountTransactionId !== undefined) {
      input.financialAccountTransactionId =
        params.financialAccountTransactionId;
    }

    return {
      financePaymentUpdate: {
        __args: {
          id: params.id,
          input,
        },
        id: true,
        documentNumber: true,
        status: true,
        transactionDate: true,
        amount: {
          amount: true,
          currencyCode: true,
        },
        paymentMethod: true,
        checkNumber: true,
        checkMemo: true,
        achNumber: true,
        wireNumber: true,
        financialAccountId: true,
        financialAccountTransactionId: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    };
  },
);
